import { action } from "@ember/object"
import Component from "@glimmer/component"
import type { RotationCalendar } from "@shared/models/rotation-calendar"

interface Args {
  dates: any
  rotationCalendarType: string
  rotationCalendar: RotationCalendar
  dateWidth: number
  planbookDatesOff: any
  timelineHeight: number
  timelineWidth: number
  highlightedDates: any
}

export default class TimelineDates extends Component<Args> {
  readonly watchForStickyElementOptions = {
    rootMargin: "-100px 0px 0px 0px",
    threshold: [1],
  }

  get height() {
    if (this.args.rotationCalendarType === "block") {
      return "90px"
    } else {
      return "65px"
    }
  }

  get dateHeight() {
    if (this.args.rotationCalendarType === "block") {
      return "60px"
    } else {
      return "36px"
    }
  }

  @action
  watchForStickyElement([e]) {
    e.target.classList.toggle("--is-sticky", e.intersectionRatio < 1)
  }
}
